import { AutogenModelHierarchy, AutogenRowHierarchy } from "./autogen/AutogenModelHierarchy";

export class ModelHierarchy extends AutogenModelHierarchy<RowHierarchy> {
    constructor() {
        super(RowHierarchy);
    }
}

export class RowHierarchy extends AutogenRowHierarchy {
}